import React, { Component, Fragment } from 'react';
import { Logging, CustomLoading } from './LoadingComponent';
import { connect } from 'react-redux';
import { Breadcrumb, BreadcrumbItem, Label, Input, Button, Alert, ButtonGroup, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { CSVLink } from "react-csv";
import { sort_by, CustomListSelect, CustomSelect, array_groupby, sum_array, 
         toMoney, previous_date, valid_url, unique_values, filtered_data } from './Functions';
import { RenderVirtualTable } from './TableComponent';
import { PiePlot, BarPlot, MultLineTsPlot } from './PlotComponent';
import { client_perf_levels } from '../shared/data';
import { postRequest } from '../redux/ActionCreators';


// import { Auth } from 'aws-amplify';
const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
    client_portfolio: state.client_portfolio,
    client_port_exposure: state.client_port_exposure,
    client_port_metrics: state.client_port_metrics,
    client_performance: state.client_performance,
    client_params: state.client_params
  };
};

class ClientPortExposure extends Component {
  constructor(props){
      super(props);
      this.state = {
        loading_portfolio:false,
        loading_performance:false,
        loading_flows:false,
        downloading_flows:false,
        port_id:'Portafolio',
        show_fx:true,
        msg:null,
        msg_perf:null,
        perf_filter:[{field:null, value:null}],
        perf_warnings:false,
        search_flows:null,
        search_detail:null,
        search_detail_grouped:null,
        sortby: null,
        sortby_flows:null,
        sortby_grouped: null,
        filter_summ_cols:false,
        filter_perf_cols:false,
        filter_flow_cols:false
      };
      this.loadPortfolio = this.loadPortfolio.bind(this);
      this.loadPerformance = this.loadPerformance.bind(this);
      this.downloadFlows = this.downloadFlows.bind(this);
      this.loadFlows = this.loadFlows.bind(this);
      this.header = this.header.bind(this);
  }
  
  async loadPortfolio(){
    let client_port;
    if (this.props.client_params.port_name=='' || this.props.client_params.port_name==null) {
      this.setState({msg:"Seleccionar portafolio!"});
    } else {
      this.setState({msg:null});
      this.setState({loading_portfolio:true});
      await this.props.changeModel('client_port_metrics', null);
      try {
        client_port = await postRequest(
          { 
            client_id:this.props.client_params.port_name, 
            cty:this.props.user_wm.data.client_ports.find(x=>x.clientId==this.props.client_params.port_name).cty,
            table_name:"positions",
            ini_date:this.props.client_params.port_date,
            ref_date:this.props.client_params.port_date,
          }, 'query_client_portfolio');
        
        if (client_port.status=='ok') {
          await this.props.changeModel('client_portfolio', client_port);
          await this.props.changeModel('client_params.perf_date', this.props.client_params.port_date);
          await this.props.changeModel('client_params.flows', null);
          await this.props.changeModel('client_params.show_flows', false);
          this.setState({perf_filter:[{field:null, value:null}]});
          await this.loadPerformance();
        } else {
          this.setState({
            msg:'Error cargando portafolio.',
            loading_portfolio:false
          });
          await this.props.changeModel('client_portfolio', null);
          await this.props.changeModel('client_port_exposure', null);
          await this.props.changeModel('client_params.flows', null);
          await this.props.changeModel('client_params.show_flows', false);
          return;
        }
      } catch (error) {
        client_port = null;
        await this.props.changeModel('client_portfolio', null);
        await this.props.changeModel('client_port_exposure', null);
        await this.props.changeModel('client_params.flows', null);
        await this.props.changeModel('client_params.show_flows', false);
        this.setState({
          msg: error.message,
          loading_portfolio:false
        });
        return;
      }

      try {
        if (client_port.status=='ok') {
          const client_port_exp = await postRequest(
            { 
              port:client_port.port.map(item=>{
                return {isin:item.isin, name:item.assetName, value:item.mktValue, benchmark:item.benchmark};
              }), 
              bench:null,
              use_assets_bench:this.props.client_params.assets_bench
            }, 'port_exposure_wm');
          await this.props.changeModel('client_port_exposure', client_port_exp);
        } else {
          this.setState({msg:'Error calculando exposición.'});
          await this.props.changeModel('client_port_exposure', null);
        }
        this.setState({loading_portfolio:false});
      } catch (error) {
        await this.props.changeModel('client_port_exposure', null);
        this.setState({
          loading_portfolio:false,
          msg: `Error calculando exposición (${error.message})`
        });
      }
    }
  }


  async loadPerformance(){
    if (this.props.client_params.perf_select_fields && this.props.client_params.perf_fields.length==0) {
      this.props.changeModel("client_params.perf_fields", []);
    }
    this.setState({msg_perf:null});
    this.setState({loading_performance:true});
    try {
      const client_perf = await postRequest(
        { 
          client_id:this.props.client_params.port_name, 
          cty:this.props.user_wm.data.client_ports.find(x=>x.clientId==this.props.client_params.port_name).cty,
          table_name:"performance",
          ini_date:this.props.client_params.activate_initial_date ? this.props.client_params.ini_date : null,
          ref_date:this.props.client_params.perf_date,
          period:this.props.client_params.activate_initial_date ? null : this.props.client_params.period,
          perf_summary:true,
          return_series:true,
          perf_fields:this.props.client_params.perf_select_fields ? this.props.client_params.perf_fields.map(x=>x.value) : null,
          perf_level:this.props.client_params.perf_select_fields ? null : this.props.client_params.perf_level,
          cash_fx_return:this.props.client_params.cash_fx_return,
          ignore_cash_exposure:this.props.client_params.ignore_cash_exposure,
          remove_st:this.props.client_params.remove_st,
          use_return_proxy:this.props.client_params.use_return_proxy
          //method:this.props.client_params.perf_method
        }, 'query_client_portfolio');
      if (client_perf.status=='ok') {
        await this.props.changeModel('client_performance', client_perf);
        this.setState({perf_filter:[{field:null, value:null}]});
      } else {
        this.setState({msg_perf:'Error cargando desempeño.'});
        await this.props.changeModel('client_performance', null);
      }
    } catch (error) {
      await this.props.changeModel('client_performance', null);
      this.setState({
        msg_perf: `Error cargando desempeño (${error.message})`
      });
    }
    await this.props.changeModel('client_params.flows', null);
    await this.props.changeModel('client_params.show_flows', false);
    this.setState({
      loading_performance: false
    });
  }

  async downloadFlows(){
    this.setState({downloading_flows:true});
    this.setState({msg_perf:null});
    try {
      const flows = await postRequest(
        { 
          client_id:this.props.client_params.port_name, 
          cty:this.props.user_wm.data.client_ports.find(x=>x.clientId==this.props.client_params.port_name).cty,
          table_name:"flows",
          ini_date:this.props.client_params.activate_initial_date ? this.props.client_params.ini_date : null,
          ref_date:this.props.client_params.perf_date,
          period:this.props.client_params.activate_initial_date ? null : this.props.client_params.period,
          filter: null,
          res_url:true
        }, 'query_client_portfolio');
      
      if (flows.status=='ok' & valid_url(flows.port)) {
        window.location.replace(String(flows.port));
      } else {
        this.setState({
          msg_perf:'Error descargando flujos.',
          downloading_flows:false
        });
        return;
      }
    } catch (error) {
      this.setState({
        msg_perf: `Error descargando flujos(${error.message})`,
        downloading_flows:false
      });
    }
    this.setState({
      downloading_flows:false
    });
  }

  async loadFlows(checked){
    if (this.props.client_params.flows==null && checked){
      this.setState({loading_flows:true});
      this.setState({msg_perf:null});
      try {
        const flows = await postRequest(
          { 
            client_id:this.props.client_params.port_name, 
            cty:this.props.user_wm.data.client_ports.find(x=>x.clientId==this.props.client_params.port_name).cty,
            table_name:"flows",
            ini_date:this.props.client_params.activate_initial_date ? this.props.client_params.ini_date : null,
            ref_date:this.props.client_params.perf_date,
            period:this.props.client_params.activate_initial_date ? null : this.props.client_params.period,
            //filter: this.state.perf_filter?.field == null || this.state.perf_filter?.value == null ? null : {field:this.props.client_params.perf_variables.find(x=>x.label==this.state.perf_filter.field).name, value:[this.state.perf_filter.value]},
            res_url:false
          }, 'query_client_portfolio');
        if (flows.status=='ok') {
          await this.props.changeModel('client_params.flows', 
            flows.port.map(row => ({
              ...Object.fromEntries(
                Object.keys(row)
                  .map(col => {
                    const variable = this.props.client_params.flow_variables.find(v => v.name === col);
                    if (!variable) return false;
                    return [variable.label, row[col]];
                  })
                  .filter(entry => entry !== false)
              )
            }))
            );
        } else {
          this.setState({msg_perf:'Error cargando desempeño.'});
          await this.props.changeModel('client_params.flows', null);
        }
      } catch (error) {
        this.setState({
          msg_perf: `Error descargando flujos(${error.message})`,
        });
      }
      this.setState({
        loading_flows:false
      });
    }
  }

  header(){
    return(
      <>
        <div className="row mt-5 justify-content-center">
          <div className="col-auto">
            <h4>Análisis de Portafolio</h4>
          </div>
        </div>
        <div className="row m-3 justify-content-center">
          <div className="col-auto">
            <Breadcrumb>
              <BreadcrumbItem active>Chequeo del Portafolio</BreadcrumbItem>
              <BreadcrumbItem><Link to='/client_portfolio/stage/metrics'>Evaluación de Riesgo</Link></BreadcrumbItem>
              <BreadcrumbItem><Link to='/client_portfolio/stage/suitability'>Alineación de Estrategia de Inversión</Link></BreadcrumbItem>
              <BreadcrumbItem><Link to='/client_portfolio/stage/adjust'>Ajuste de Portafolio</Link></BreadcrumbItem>
            </Breadcrumb>
          </div>
        </div>
        <div className="row m-3 justify-content-center">
          <div className='col-auto'>
            <Label check>
              <Input type="checkbox"
                checked={this.props.client_params.assets_bench}
                onChange={()=>this.props.changeModel("client_params.assets_bench", !this.props.client_params.assets_bench)}
                />{' '}
                <small>usar benchmarks</small>
            </Label>
          </div>
          <div className='col-md-3'>
            <CustomListSelect
              options={this.props.user_wm.data.client_ports.map(x=>{
                return {value:x.clientId, label:(x.cty=="PE" ? x.clientId.slice(0,10) : x.clientId) + " | " + x.cty};
              })}
              isClearable={true}
              value={this.props.client_params.port_name==null ? null : {value:this.props.client_params.port_name, label:this.props.client_params.port_name}}
              onChange={(e)=>this.props.changeModel("client_params.port_name", e==null ? null : e.value)}
              itemSize={30}
              className="basic-single"
              placeholder="seleccionar cliente"
            />
          </div>
          <div className='col-auto'>
              <Input 
                size="sm"
                type="date"
                value={this.props.client_params.port_date}
                onChange={(e)=>{
                 this.props.changeModel("client_params.port_date", e.target.value)
                 if (e.target.value<this.props.client_params.ini_date){
                   this.props.changeModel("client_params.ini_date", previous_date("MTD", e.target.value))
                 }
                }}
              />
          </div>
          <div className='col-auto'>
            <Button 
              className="btn-corp"
              onClick={this.loadPortfolio}
            >
              Consultar Portafolio
            </Button>
          </div>
        </div>
      </>
      );
  }

  render() {
      if(this.props.user_wm.isLogging){
        return(
          <div className='container'>
            <div className="row justify-content-center">
                <Logging />
            </div>
          </div>
        );
      } else if (this.state.loading_portfolio){
          return(
            <div className='container'>
              {this.header()}
              <div className="row justify-content-center m-5">
                <CustomLoading msg="consultando portafolio de cliente" icon="fa-compass" />
              </div>
            </div>
          );
      } else if (this.props.client_portfolio==null){
          return(
            <div className='container'>
              {this.header()}
              <div className="row mt-4 justify-content-center">
                <div className="col-6 m-3">
                  <Alert
                    color={this.state.msg!==null && this.state.msg.includes('Error') ? 'danger':'secondary'}
                    isOpen={this.state.msg!=='' && this.state.msg!==null} 
                    toggle={()=>this.setState({msg:null})}
                    fade={false}
                    >
                      {this.state.msg}
                  </Alert>
                </div>
              </div>
              <div className="row justify-content-center m-2">
                  <h6>No hay datos disponibles.</h6>
              </div>
            </div>
          );
      } else {
        let port_saa = [...this.props.client_portfolio.port.filter(x=>x.weight>0 & x.referenceDate==this.props.client_portfolio.ref_dates[1]).map(({assetName,mktValue,ccy,weight})=>({assetName,mktValue,ccy,weight}))].sort(sort_by('weight', "desc"));
        let port_assetclass_exp = this.props.client_port_exposure==null ? null : array_groupby(this.props.client_port_exposure.w_ac, 'AssetClass', 'Portafolio').sort(sort_by('value')).filter(x=>x.value>1e-4);
        let port_curr_exp = this.props.client_port_exposure==null ? null : array_groupby(this.props.client_port_exposure.w_ac, 'Currency', 'Portafolio').sort(sort_by('value')).filter(x=>x.value>1e-4);
        let port_mkt_exp = this.props.client_port_exposure==null ? null : array_groupby(this.props.client_port_exposure.w_market, 'Market', 'Portafolio').sort(sort_by('value')).filter(x=>x.value>1e-4);
  
        // Performacnce
        const perf_view_ind = this.props.user_wm.data.client_ports.find(x=>x.clientId==this.props.client_params.port_name)?.cty=="CL";
        const ref_dates_perf = this.props.client_performance?.ref_dates;

        const perf_summary_tbl = this.props.client_performance?.perf_summary
          ? this.props.client_performance.perf_summary
              .filter(row => row.currency == this.props.client_params.perf_ccy)
              .map(row => ({
                ...Object.fromEntries(
                  Object.keys(row)
                    .filter(col => {
                      const variable = this.props.client_params.perf_variables.find(v => v.name === col);
                      return variable?.include;
                    })
                    .map(col => {
                      const variable = this.props.client_params.perf_variables.find(v => v.name === col);
                      return [variable.label, row[col]];
                    })
                )
              }))
          : null;        

        const perf_summary_tbl_show = perf_summary_tbl ? perf_summary_tbl.filter(row=>
            !this.state.perf_filter ||
            this.state.perf_filter.length === 0 ||
            this.state.perf_filter.every(f =>
              f.field == null ||
              f.value == null ||
              (Array.isArray(f.value)
                ? f.value.length === 0 || f.value.includes(row[f.field])
                : row[f.field] === f.value
              )
            )
          )
          :null;

        const perf_filter_options = perf_summary_tbl ? 
          this.props.client_params.perf_variables.filter(x=>x.grouper && Object.keys(perf_summary_tbl[0]).includes(x.label)).map(k=>k.label) : null;

        const client_series = this.props.client_performance?.series
          ? this.props.client_performance.series
            .map(item=>{
              return {Fecha:item.referenceDate, "Valor":item[this.props.client_params.perf_ccy]};
          })
          : null;
        
        const perf_detail_grouped = perf_summary_tbl ? this.props.client_performance.perf_grouped_daily.filter(
            row =>
              row.currency === this.props.client_params.perf_ccy &&
              (
                !this.state.perf_filter ||
                this.state.perf_filter.length === 0 ||
                this.state.perf_filter.every(f =>
                  f.field == null ||
                  f.value == null ||
                  (Array.isArray(f.value)
                    ? f.value.length === 0 || f.value.includes(row[this.props.client_params.perf_variables.find(k => k.label === f.field).name])
                    : row[this.props.client_params.perf_variables.find(k => k.label === f.field).name] === f.value
                  )
                )
              )
          )
          : null;        

        const perf_detail_grouped_show = perf_detail_grouped ? 
          filtered_data(
            perf_detail_grouped.map(row => ({
              ...Object.fromEntries(
                Object.keys(row)
                  .filter(col => {
                    const variable = this.props.client_params.perf_detail_grouped_variables.find(v => v.name === col);
                    return variable?.include;
                  })
                  .map(col => {
                    const variable = this.props.client_params.perf_detail_grouped_variables.find(v => v.name === col);
          
                    let value = row[col];
                    if (["unnorm_ret", "w_return", "weight"].some(x => col.includes(x))) {
                       value *= 100;
                     }
                    return [variable.label, value];
                  })
              )
            })).sort(sort_by(this.state.sortby_grouped, "desc", true))
          , this.state.search_detail_grouped)
        : null;

      const perf_detail = perf_summary_tbl ? this.props.client_performance.port.filter(
          row =>
            row.referenceDate > this.props.client_performance.ref_dates[0] &&
            row.currency === this.props.client_params.perf_ccy &&
            (
              !this.state.perf_filter ||
              this.state.perf_filter.length === 0 ||
              this.state.perf_filter.every(f =>
                f.field == null ||
                f.value == null ||
                (Array.isArray(f.value)
                  ? f.value.length === 0 || f.value.includes(row[this.props.client_params.perf_variables.find(k => k.label === f.field).name])
                  : row[this.props.client_params.perf_variables.find(k => k.label === f.field).name] === f.value
                )
              )
            )
        ) : null;

        const perf_detail_show = perf_detail ? 
          filtered_data(
            perf_detail.filter(row=>this.state.perf_warnings ? row["status"]!=="normal" : true).map(row => ({
              ...Object.fromEntries(
                Object.keys(row)
                  .filter(col => {
                    const variable = this.props.client_params.perf_detail_variables.find(v => v.name === col);
                    return variable?.include;
                  })
                  .map(col => {
                    const variable = this.props.client_params.perf_detail_variables.find(v => v.name === col);
          
                    let value = row[col];
                    if (col.includes("return")) {
                      value *= 100;
                    }
          
                    return [variable.label, value];
                  })
              )
            })).sort(sort_by(this.state.sortby, "desc", true))
          , this.state.search_detail)
        : null;

        const flows_tbl = this.props.client_params.flows ? 
          filtered_data(
            this.props.client_params.flows.filter(
              row=>
              (
                !this.state.perf_filter ||
                this.state.perf_filter.length === 0 ||
                this.state.perf_filter.every(f =>
                  f.field == null ||
                  f.value == null ||
                  (Array.isArray(f.value)
                    ? f.value.length === 0 || f.value.includes(row[f.field])
                    : row[f.field] === f.value
                  )
                )
              )
            )
          , this.state.search_flows) : null;

        const flows_tbl_show = flows_tbl ? 
            flows_tbl.map(row => ({
              ...Object.fromEntries(
                Object.keys(row)
                  .filter(col => {
                    const variable = this.props.client_params.flow_variables.find(v => v.label === col);
                    return variable?.include;
                  })
                  .map(col => {
                    const variable = this.props.client_params.flow_variables.find(v => v.label === col);
                    let value = row[col];
                    return [variable.label, value];
                  })
              )
            })).sort(sort_by(this.state.sortby_flows, "desc", true))
        : null;
        const cols_summ_form = this.props.client_params.perf_variables.filter(k=>!k.grouper & (k.to_perc || k.to_money)).map((item,i)=>{
          return (
            <div className='row justify-content-start' key={i}>
              <div className='col-auto'>
                <Label check>
                  <Input type="checkbox"
                    checked={item.include}
                    onChange={()=>{
                      const cols_perf_udt = [...this.props.client_params.perf_variables];
                      const idx = cols_perf_udt.findIndex(x=>x.label===item.label);
                      cols_perf_udt[idx] = {...item, include:!item.include};
                      this.props.changeModel('client_params.perf_variables', cols_perf_udt);
                    }}
                    />
                    {"   "}{item.label}
                </Label>
              </div>
            </div>
            );
        });

        const cols_perf_form = this.props.client_params.perf_detail_variables.filter(k=>!k.grouper).map((item,i)=>{
          return (
            <div className='row justify-content-start' key={i}>
              <div className='col-auto'>
                <Label check>
                  <Input type="checkbox"
                    checked={item.include}
                    onChange={()=>{
                      const cols_perf_udt = [...this.props.client_params.perf_detail_variables];
                      const idx = cols_perf_udt.findIndex(x=>x.label===item.label);
                      cols_perf_udt[idx] = {...item, include:!item.include};
                      this.props.changeModel('client_params.perf_detail_variables', cols_perf_udt);
                    }}
                    />
                    {"   "}{item.label}
                </Label>
              </div>
            </div>
            );
        });

        const cols_flow_form = this.props.client_params.flow_variables.map((item,i)=>{
          return (
            <div className='row justify-content-start' key={i}>
              <div className='col-auto'>
                <Label check>
                  <Input type="checkbox"
                    checked={item.include}
                    onChange={()=>{
                      const cols_flow_udt = [...this.props.client_params.flow_variables];
                      const idx = cols_flow_udt.findIndex(x=>x.label===item.label);
                      cols_flow_udt[idx] = {...item, include:!item.include};
                      this.props.changeModel('client_params.flow_variables', cols_flow_udt);
                    }}
                    />
                    {"   "}{item.label}
                </Label>
              </div>
            </div>
            );
        });
        
        const filter_form = perf_summary_tbl && perf_filter_options && perf_filter_options.length>0 ?
          this.state.perf_filter.map((item,i)=>{
            return (
            <div className="row justify-content-center mt-2">
              <div className='col-2'>
                <CustomListSelect
                  className="basic-single"
                  options={perf_filter_options.map(x=>{
                      return {value:x, label:x};
                    })}
                  fontSize={12}
                  itemSize={30}
                  value={
                    item?.field ? {label:item.field, value:item.field} 
                    : null
                  }
                  isSearchable={true}
                  isClearable={true}
                  onChange={(e)=>{
                   const perf_filter_temp = [...this.state.perf_filter];
                   perf_filter_temp[i] = {field:e?.value, value:null};
                   this.setState({perf_filter:perf_filter_temp}); 
                  }}
                  placeholder="filtrar..."
                />
              </div>
              {this.state.perf_filter[i]?.field ?
                <div className='col-3'>
                    <CustomSelect
                      options={unique_values(perf_summary_tbl, this.state.perf_filter[i]?.field).map(x=>{
                        return {value:x, label:x};
                      })}
                      value={item?.value ? item.value.map(k=>{
                        return {label:k, value:k};
                      }) : null}
                      onChange={(e)=>{
                       const perf_filter_temp = [...this.state.perf_filter];
                       perf_filter_temp[i] = {...this.state.perf_filter[i], value:e.map(x=>x.value)};
                       this.setState({perf_filter:perf_filter_temp});
                      }}

                      itemSize={30}
                      className="basic-multi-select"
                      placeholder="campos..."
                      fontSize={12}
                    />
                </div>
                :null
              }
            </div>
          );
          })
        : null;
        return (
          <div className="container">
            {this.header()}

            <div className="row mt-4 justify-content-center">
              <div className="col-6 m-3">
                <Alert
                  color={this.state.msg!==null && this.state.msg.includes('Error') ? 'danger':'secondary'}
                  isOpen={this.state.msg!=='' && this.state.msg!==null} 
                  toggle={()=>this.setState({msg:null})}
                  fade={false}>
                    {this.state.msg}
                </Alert>
              </div>
            </div>

            <div className="row m-4 justify-content-center">
              <div className='col' id="summ">
                <h5><b>Posicionamiento</b></h5>
                {perf_view_ind!==null ? <a className='linkcol' href='#exp'>desempeño&darr;{"    "}</a> : null}
                {port_assetclass_exp!==null ? <a className='linkcol' href='#exp'>exposición&darr;</a> : null}
              </div>
            </div>
            <div className="row mt-4 justify-content-center">
              <div className='col' id="summ">
                <p>Valor del portafolio ({this.props.client_portfolio.ref_dates[1]}): <b>{toMoney(sum_array(port_saa.map(x=>x.mktValue)))}</b></p>
              </div>
            </div>
            <div className="row justify-content-center align-items-center">
              <div className='col-md-6'>
                <div className='row justify-content-center'>
                  <div className='col-auto'>
                    <RenderVirtualTable 
                      data={port_saa} 
                      to_perc={[false, false, false, true]}
                      to_money={[false, true, false, false]}
                      cell_width={["250px", '120px', '80px', '80px']}
                      item_size={40}
                      fontsize={10}
                      style="black"
                      />
                  </div>
                </div>
                <div className='row m-2'>
                  <div className='col'>
                    <CSVLink className='link-btn' data={this.props.client_portfolio.port.filter(x=>x.weight>0)} filename="portfolio"><small>Descargar portafolio &darr;</small></CSVLink>
                  </div>
                </div>
              </div>
              {port_saa.filter(x=>x.weight>1e-4).length>10 ?
              <div className='col-md-6'>
                <h6>Posiciones (top 10)</h6>
                <BarPlot 
                  y={port_saa.filter(x=>x.weight>1e-4).slice(0,10).map(x=>x.assetName.length > 30 ? `${x.assetName.slice(0, 30)}...` : x.assetName)}
                  x={port_saa.filter(x=>x.weight>1e-4).slice(0,10).map(x=>x.weight)}
                  layout="vertical"
                  angle={0}
                  ytype="category" xtype="number"
                  color="#000000"
                  xpercAxis={true}
                  percTooltip={true}
                  width={500}
                  top={0}
                  interval={0}
                  height={400}
                  barsize={10}
                  fontsize={12}
                />
              </div>
              :<div className='col-md-6'>
                <PiePlot 
                  data={port_saa.filter(x=>x.weight>1e-4)} 
                  width={600}
                  height={450}
                  outerRadius={100}
                  percTooltip={true}
                  legend={true}
                  legendHeight={120}
                  dataKey='weight'
                  nameKey='assetName'
                />
              </div>
              }
            </div>
            {/*Performance*/}
            {perf_view_ind ?
            <>
              <div className="row m-4 justify-content-center">
                <div className='col'>
                  <hr></hr>
                </div>
              </div>
              <div className="row mt-4 justify-content-center">
                <div className='col' id="exp">
                  <h5><b>Desempeño</b></h5>
                  {ref_dates_perf ?
                    <div className="row justify-content-center" >
                      <div className="col-auto">
                      <p className="m-0"><small>{ref_dates_perf[0]}/{ref_dates_perf[1]}</small></p>
                      </div>
                    </div>
                  : null
                  }

                  <a className='linkcol' href='#summ'>posicionamiento&uarr;{"     "}</a>
                  {port_assetclass_exp!==null ? <a className='linkcol' href='#exp'>exposición&uarr;</a> : null}
                </div>
              </div>
              <div className="row mt-4 justify-content-center align-items-center">
                <div className='col-auto'>
                  <Label check>
                    <Input type="checkbox"
                      checked={this.props.client_params.perf_select_fields}
                      onChange={()=>this.props.changeModel("client_params.perf_select_fields", !this.props.client_params.perf_select_fields)}
                      />{' '}
                      <small>seleccionar campos</small>
                  </Label>
                </div>
                {this.props.client_params.perf_select_fields ?
                  <div className='col-md-3'>
                    <CustomSelect
                      name="assets"
                      value={this.props.client_params.perf_fields}
                      options={this.props.client_params.perf_variables.filter(x=>x.grouper).map(item=>{
                        return {value:item.name, label:item.label};
                      })}
                      onChange={(e)=>{this.props.changeModel('client_params.perf_fields', e.map(x=>{
                        return {value:x.value, label:x.label};
                      }))}}
                      itemSize={30}
                      className="basic-multi-select"
                      placeholder="campos..."
                      fontSize={12}
                    />
                  </div>
                :
                  <div className='col-md-3'>
                    <CustomListSelect
                      options={Object.keys(client_perf_levels).map(x=>{
                        return {value:x, label:x.replace("_", " ")};
                      })}
                      isClearable={false}
                      value={this.props.client_params.perf_level==null ? null : {value:this.props.client_params.perf_level, label:this.props.client_params.perf_level.replace("_", " ")}}
                      onChange={(e)=>this.props.changeModel("client_params.perf_level", e==null ? null : e.value)}
                      itemSize={30}
                      className="basic-single"
                      placeholder="seleccionar reporte"
                      fontSize={12}
                    />
                  </div>
                }
                {this.state.loading_performance ?
                  <div className='col-3'>
                    <CustomLoading 
                      mt={2}
                      msg="consultando desempeño. No salgas de esta página" 
                      icon="fa-compass" 
                    />
                  </div>
                :
                  <div className='col-auto'>
                    <Button 
                      className="btn-corp"
                      onClick={this.loadPerformance}
                    >
                      Consultar Desempeño
                    </Button>
                  </div>
                }                
              </div>
              <div className="row mt-3 justify-content-center align-items-center">
                <div className='col-auto'>
                  <Label check>
                    <Input type="checkbox"
                      checked={this.props.client_params.activate_initial_date}
                      onChange={(e)=>{
                        this.props.changeModel('client_params.activate_initial_date',!this.props.client_params.activate_initial_date);
                        if (e.target.checked){
                          this.props.changeModel("client_params.ini_date", previous_date(this.props.client_params.period, this.props.client_params.perf_date));
                        }
                      }}
                      />{' '}
                      <small>activar fecha inicial</small> 
                  </Label>
                </div>
                {this.props.client_params.activate_initial_date ?
                  <div className='col-auto'>
                      <Input 
                        size="sm"
                        type="date"
                        value={this.props.client_params.ini_date}
                        onChange={(e)=>{
                          this.props.changeModel("client_params.ini_date", e.target.value<=this.props.client_params.perf_date ? e.target.value : this.props.client_params.perf_date);
                        }}
                      />
                  </div>
                :
                  <div className='col-auto'>
                    <Input size="sm" type="select" value={this.props.client_params.period} onChange={(e)=>this.props.changeModel('client_params.period',e.target.value)}>
                      {["MTD", "YTD", "1M", "3M", "6M", '12M'].map((x,i)=>{
                        return (<option key={i}>{x}</option>);
                      })}
                    </Input>
                  </div>
                }
                <div className='col-auto'>
                    <Input 
                      size="sm"
                      type="date"
                      value={this.props.client_params.perf_date}
                      onChange={(e)=>{
                       this.props.changeModel("client_params.perf_date", e.target.value)
                       if (e.target.value<this.props.client_params.ini_date){
                         this.props.changeModel("client_params.ini_date", previous_date("MTD", e.target.value))
                       }
                      }}
                    />
                </div>
                <div className='col-md-1'>
                  <CustomListSelect
                    options={["CLP", "USD"].map(x=>{
                      return {value:x, label:x};
                    })}
                    isClearable={false}
                    value={this.props.client_params.perf_ccy==null ? null : {value:this.props.client_params.perf_ccy, label:this.props.client_params.perf_ccy}}
                    onChange={(e)=>this.props.changeModel("client_params.perf_ccy", e==null ? null : e.value)}
                    itemSize={30}
                    className="basic-single"
                    placeholder="seleccionar moneda"
                    fontSize={12}
                  />
                </div>
              </div>
              <div className="row mt-3 justify-content-center align-items-center">
                <div className='col-auto'>
                  <ButtonGroup size='sm'>
                    <Button
                      color="dark"
                      outline
                      onClick={() => this.props.changeModel('client_params.use_return_proxy', false)}
                      active={!this.props.client_params.use_return_proxy}
                    >
                      <small>Retorno Original</small>
                    </Button>
                    <Button
                      color="dark"
                      outline
                      onClick={() => this.props.changeModel('client_params.use_return_proxy', true)}
                      active={this.props.client_params.use_return_proxy}
                    >
                      <small>Retorno Aprox.</small>
                    </Button>
                  </ButtonGroup>
                </div>
                <div className='col-auto'>
                  <Label check>
                    <Input type="checkbox"
                      checked={this.props.client_params.cash_fx_return}
                      onChange={()=>this.props.changeModel("client_params.cash_fx_return", !this.props.client_params.cash_fx_return)}
                      />{' '}
                      <small>Retorno Caja FX</small>
                  </Label>
                </div>
                <div className='col-auto'>
                  <Label check>
                    <Input type="checkbox"
                      checked={this.props.client_params.ignore_cash_exposure}
                      onChange={()=>this.props.changeModel("client_params.ignore_cash_exposure", !this.props.client_params.ignore_cash_exposure)}
                      />{' '}
                      <small>Ignorar Exp. Caja</small>
                  </Label>
                </div>
                <div className='col-auto'>
                  <Label check>
                    <Input type="checkbox"
                      checked={this.props.client_params.remove_st}
                      onChange={()=>this.props.changeModel("client_params.remove_st", !this.props.client_params.remove_st)}
                      />{' '}
                      <small>Excluir saldos en tránsito</small>
                  </Label>
                </div>
                {this.state.perf_filter.at(-1)?.field && this.state.perf_filter.at(-1)?.value ?
                  <div className='col-auto'>
                    <Button className='link-btn'
                      onClick={()=>this.setState({perf_filter:[...this.state.perf_filter, {field:null, value:null}]})}
                    >
                      <small>agregar filtro&#9998;</small>
                    </Button>
                  </div>
                : null
                }
                {this.state.perf_filter.length>1 ?
                  <div className='col-auto'>
                    <Button className='link-btn'
                      onClick={()=>this.setState({perf_filter:this.state.perf_filter.slice(0, -1)})}
                    >
                      <small>eliminar filtro&#9998;</small>
                    </Button>
                  </div>
                : null
                }
                {/*
                <div className='col-auto'>
                  <ButtonGroup size='sm'>
                    <Button
                      color="dark"
                      outline
                      onClick={() => this.props.changeModel('client_params.perf_method', "ME")}
                      active={this.props.client_params.perf_method==="ME"}
                    >
                      <small>Máx. Exp.</small>
                    </Button>
                    <Button
                      color="dark"
                      outline
                      onClick={() => this.props.changeModel('client_params.perf_method', "EOD")}
                      active={this.props.client_params.perf_method==="EOD"}
                    >
                      <small>EOD</small>
                    </Button>
                  </ButtonGroup>
                </div
                */
                }
              </div>
              {this.state.msg_perf ?
              <div className="row mt-4 justify-content-center">
                <div className="col-6 m-3">
                  <Alert
                    color={this.state.msg_perf!==null && this.state.msg_perf.includes('Error') ? 'danger':'secondary'}
                    isOpen={this.state.msg_perf!=='' && this.state.msg_perf!==null} 
                    toggle={()=>this.setState({msg_perf:null})}
                    fade={false}
                    >
                      {this.state.msg_perf}
                  </Alert>
                </div>
              </div>
              :null                
              }
              <div className="mt-4">
                {filter_form}
              </div>
              {perf_summary_tbl_show ?
              <>
                <div className='row justify-content-center mt-4'>
                  <div className='col-auto'>
                    <RenderVirtualTable 
                      data={perf_summary_tbl_show}
                      to_perc={Object.keys(perf_summary_tbl[0]).map(k=>this.props.client_params.perf_variables.find(x=>x.label==k).to_perc)}
                      to_money={Object.keys(perf_summary_tbl[0]).map(k=>this.props.client_params.perf_variables.find(x=>x.label==k).to_money)}
                      to_fixed={Object.keys(perf_summary_tbl[0]).map(k=>this.props.client_params.perf_variables.find(x=>x.label==k).to_fixed)}
                      cell_width={Object.keys(perf_summary_tbl[0]).map(k=>this.props.client_params.perf_variables.find(x=>x.label==k).width)}
                      item_size={40}
                      fontsize={10}
                      style="black"
                      />
                  </div>
                </div>
                <div className='row justify-content-center align-items-center mt-2'>
                  <div className='col-auto'>
                    <CSVLink className='link-btn' data={perf_summary_tbl} filename="resumen"><small>descargar resumen&darr;</small></CSVLink>
                  </div>
                  <div className='col-auto'>
                    <CSVLink 
                      className='link-btn' 
                      data={perf_detail}
                      filename="detalle"><small>descargar detalle&darr;</small></CSVLink>
                  </div>
                  <div className='col-auto'>
                    <Button
                      className='link-btn'
                      onClick={this.downloadFlows}
                    >
                      {this.state.downloading_flows ? <CustomLoading msg="descargando flujos" icon="fa-compass" mt="2"/> : <small>descargar flujos&darr;</small>}
                    </Button>
                  </div>
                  <div className='col-auto'>
                    <CSVLink className='link-btn' data={client_series} filename="serie"><small>descargar serie consolidada&darr;</small></CSVLink>
                  </div>
                  <div className='col-auto'>
                    <Button className='link-btn'
                      onClick={()=>this.setState({filter_summ_cols:!this.state.filter_summ_cols})}
                    >
                      <small>editar&#9998;</small>
                    </Button>
                  </div>

                </div>
                <Modal isOpen={this.state.filter_summ_cols} toggle={()=>this.setState({filter_summ_cols:!this.state.filter_summ_cols})} size="sm">
                  <ModalHeader toggle={()=>this.setState({filter_summ_cols:!this.state.filter_summ_cols})}>Filtrar columnas</ModalHeader>
                  <ModalBody>
                    {cols_summ_form}
                  </ModalBody>
                </Modal>
                <Modal isOpen={this.state.filter_perf_cols} toggle={()=>this.setState({filter_perf_cols:!this.state.filter_perf_cols})} size="sm">
                  <ModalHeader toggle={()=>this.setState({filter_perf_cols:!this.state.filter_perf_cols})}>Filtrar columnas</ModalHeader>
                  <ModalBody>
                    {cols_perf_form}
                  </ModalBody>
                </Modal>
                <div className='row justify-content-center align-items-center mt-4'>
                  <div className='col-auto'>
                    <Label check>
                      <Input type="checkbox"
                        checked={this.props.client_params.show_detail_grouped}
                        onChange={()=>this.props.changeModel("client_params.show_detail_grouped", !this.props.client_params.show_detail_grouped)}
                        />{' '}
                        <small>ver detalle agrupado</small>
                    </Label>
                  </div>
                  <div className='col-auto'>
                    <Label check>
                      <Input type="checkbox"
                        checked={this.props.client_params.show_detail}
                        onChange={()=>this.props.changeModel("client_params.show_detail", !this.props.client_params.show_detail)}
                        />{' '}
                        <small>ver detalle por instrumento</small>
                    </Label>
                  </div>
                  <div className='col-auto'>
                    <Label check>
                      <Input type="checkbox"
                        checked={this.props.client_params.show_flows}
                        onChange={(e)=>{
                         this.props.changeModel("client_params.show_flows", !this.props.client_params.show_flows);
                         if (this.props.client_params.flows==null){
                          this.loadFlows(e.target.checked);
                         }
                        }}
                        />{' '}
                        <small>ver flujos</small>
                    </Label>
                  </div>
                </div>
                {this.props.client_params.show_detail ?
                <>
                  <div className="row mt-2 justify-content-center">
                    <div className='col'>
                      <hr></hr>
                    </div>
                  </div>
                  <div className="row mt-4 justify-content-center">
                    <div className="col">
                      <h6>Detalle por Instrumento</h6>
                    </div>
                  </div>
                  <div className="row mt-1 justify-content-center">
                    <div className='col-3'>
                      <Input 
                        size="sm"
                        type="textarea" 
                        name="search_detail" 
                        id="search_detail" 
                        rows="1"
                        placeholder="Buscar..."
                        value={this.state.search_detail || ""}
                        onChange={(e)=>{this.setState({search_detail:e.target.value})}}
                      />
                    </div>
                    <div className='col-3'>
                      <CustomListSelect
                        className="basic-single"
                        options={["Nombre Activo", "Id Activo", "Aum Inicial", "Aum Final", "Flujo Neto", "Retorno"].map((x,i)=>{
                            return {value:x, label:x};
                          })}
                        fontSize={12}
                        itemSize={30}
                        value={this.state.sortby ? {value:this.state.sortby, label:this.state.sortby} : null}
                        isSearchable={true}
                        isClearable={true}
                        onChange={(e)=>this.setState({sortby:e?.value})}  
                        placeholder="ordenar por..."
                      />
                    </div>
                  </div>
                  <div className='row justify-content-center align-items-center mt-3'>
                    <div className='col-auto'>
                      <Label check>
                        <Input type="checkbox"
                          checked={this.state.perf_warnings}
                          onChange={()=>this.setState({perf_warnings:!this.state.perf_warnings})}
                          />{' '}
                          <small>warnings</small>
                      </Label>
                    </div>
                    <div className='col-auto'>
                      <Button className='link-btn'
                        onClick={()=>this.setState({filter_perf_cols:!this.state.filter_perf_cols})}
                      >
                        <small>editar&#9998;</small>
                      </Button>
                    </div>

                  </div>
                  {perf_detail_show && perf_detail_show.length>0 ?
                    <div className='row justify-content-center mt-2'>
                      <div className='col-auto'>
                        <RenderVirtualTable 
                          data={perf_detail_show} 
                          to_perc={Object.keys(perf_detail_show[0]).map(k=>this.props.client_params.perf_detail_variables.find(x=>x.label==k).to_perc)}
                          to_money={Object.keys(perf_detail_show[0]).map(k=>this.props.client_params.perf_detail_variables.find(x=>x.label==k).to_money)}
                          to_fixed={Object.keys(perf_detail_show[0]).map(k=>this.props.client_params.perf_detail_variables.find(x=>x.label==k).to_fixed)}
                          cell_width={Object.keys(perf_detail_show[0]).map(k=>this.props.client_params.perf_detail_variables.find(x=>x.label==k).width)}
                          item_size={50}
                          fontsize={10}
                          style="black"
                          />
                      </div>
                    </div>
                    
                  : <div className='row justify-content-center mt-2'>
                      <div className='col-auto'>
                        <p>No hay datos disponibles.</p>
                      </div>
                    </div>
                  }
                </>
                :null                  
                }


                {this.props.client_params.show_detail_grouped ?
                <>
                  <div className="row mt-2 justify-content-center">
                    <div className='col'>
                      <hr></hr>
                    </div>
                  </div>
                  <div className="row mt-4 justify-content-center">
                    <div className="col">
                      <h6>Detalle por grupo</h6>
                    </div>
                  </div>
                  <div className="row mt-1 justify-content-center">
                    <div className='col-3'>
                      <Input 
                        size="sm"
                        type="textarea" 
                        name="search_detail" 
                        id="search_detail" 
                        rows="1"
                        placeholder="Buscar..."
                        value={this.state.search_detail_grouped || ""}
                        onChange={(e)=>{this.setState({search_detail_grouped:e.target.value})}}
                      />
                    </div>
                  </div>
                  {perf_detail_grouped_show && perf_detail_grouped_show.length>0 ?
                    <>
                      <div className='row justify-content-center mt-2'>
                        <div className='col-auto'>
                          <RenderVirtualTable 
                            data={perf_detail_grouped_show} 
                            to_perc={Object.keys(perf_detail_grouped_show[0]).map(k=>this.props.client_params.perf_detail_grouped_variables.find(x=>x.label==k)?.to_perc ?? false)}
                            to_money={Object.keys(perf_detail_grouped_show[0]).map(k=>this.props.client_params.perf_detail_grouped_variables.find(x=>x.label==k)?.to_money ?? false)}
                            to_fixed={Object.keys(perf_detail_grouped_show[0]).map(k=>this.props.client_params.perf_detail_grouped_variables.find(x=>x.label==k)?.to_fixed ?? false)}
                            cell_width={Object.keys(perf_detail_grouped_show[0]).map(k=>this.props.client_params.perf_detail_grouped_variables.find(x=>x.label==k)?.width ?? "70px")}
                            item_size={50}
                            fontsize={10}
                            style="black"
                            />
                        </div>
                      </div>
                      <div className='row m-3'>
                        <div className='col'>
                          <CSVLink 
                            className='link-btn' 
                            data={perf_detail_grouped_show.map(item=>{
                              return {...item, Retorno:item.Retorno/100};
                            })} 
                            filename="perf_grouped_daily"><small>Descargar performance agrupado &darr;</small></CSVLink>
                        </div>
                      </div>
                    </>
                  : <div className='row justify-content-center mt-4'>
                      <div className='col-auto'>
                        <p>No hay datos disponibles.</p>
                      </div>
                    </div>
                  }
                </>
                :null                  
                }


                {this.props.client_params.show_flows ?
                  <>
                    <div className="row mt-2 justify-content-center">
                      <div className='col'>
                        <hr></hr>
                      </div>
                    </div>
                    <div className="row mt-4 justify-content-center">
                      <div className="col">
                        <h6>Flujos</h6>
                      </div>
                    </div>
                    <div className="row mt-1 justify-content-center">
                      <div className='col-3'>
                        <Input 
                          size="sm"
                          type="textarea" 
                          name="search_text" 
                          id="search_flows" 
                          rows="1"
                          placeholder="Buscar..."
                          value={this.state.search_flows || ""}
                          onChange={(e)=>{this.setState({search_flows:e.target.value})}}
                        />
                      </div>
                      <div className='col-3'>
                        <CustomListSelect
                          className="basic-single"
                          options={["Flujo Caja", "Cantidad"].map((x,i)=>{
                              return {value:x, label:x};
                            })}
                          fontSize={12}
                          itemSize={30}
                          value={this.state.sortby_flows ? {value:this.state.sortby_flows, label:this.state.sortby_flows} : null}
                          isSearchable={true}
                          isClearable={true}
                          onChange={(e)=>this.setState({sortby_flows:e?.value})}  
                          placeholder="ordenar por..."
                        />
                      </div>
                      <div className='col-auto'>
                        <Button className='link-btn'
                          onClick={()=>this.setState({filter_flow_cols:!this.state.filter_flow_cols})}
                        >
                          <small>editar&#9998;</small>
                        </Button>
                      </div>
                      <Modal isOpen={this.state.filter_flow_cols} toggle={()=>this.setState({filter_flow_cols:!this.state.filter_flow_cols})} size="sm">
                        <ModalHeader toggle={()=>this.setState({filter_flow_cols:!this.state.filter_flow_cols})}>Filtrar columnas</ModalHeader>
                        <ModalBody>
                          {cols_flow_form}
                        </ModalBody>
                      </Modal>
                    </div>
                    {this.state.loading_flows ?
                    <div className="row mt-2 justify-content-center">
                      <CustomLoading msg="cargando flujos" icon="fa-compass" mt="2"/>
                    </div>
                    : flows_tbl_show &&  flows_tbl_show.length>0 ?
                      <>
                        <div className='row justify-content-center mt-2'>
                          <div className='col-auto'>
                            <RenderVirtualTable 
                              data={flows_tbl_show}
                              to_perc={Object.keys(flows_tbl_show[0]).map(k=>this.props.client_params.flow_variables.find(x=>x.label==k).to_perc)}
                              to_money={Object.keys(flows_tbl_show[0]).map(k=>this.props.client_params.flow_variables.find(x=>x.label==k).to_money)}
                              to_fixed={Object.keys(flows_tbl_show[0]).map(k=>this.props.client_params.flow_variables.find(x=>x.label==k).to_fixed)}
                              cell_width={Object.keys(flows_tbl_show[0]).map(k=>this.props.client_params.flow_variables.find(x=>x.label==k).width)}
                              item_size={50}
                              fontsize={10}
                              style="black"
                              />
                          </div>
                        </div>
                        <div className='row m-3'>
                          <div className='col'>
                            <CSVLink 
                              className='link-btn' 
                              data={flows_tbl_show} 
                              filename="flows"><small>Descargar flujos&darr;</small></CSVLink>
                          </div>
                        </div>
                      </>
                    :
                      <div className='row justify-content-center mt-4'>
                        <div className='col-auto'>
                          <p>No hay datos disponibles.</p>
                        </div>
                      </div>
                    }

                  </>
                :null                  
                }
              </>
                :null
              }

            </>
            :null
            }
            {client_series ?
            <>
              <div className="row mt-4 justify-content-center">
                <div className='col'>
                  <hr></hr>
                </div>
              </div>
              <div className="row mt-4 justify-content-center">
                <div className="col">
                  <h6>Serie Consolidada</h6>
                </div>
              </div>
              <div className='row mt-2 justify-content-center'>
                <div className='col-auto'>
                  <MultLineTsPlot 
                    data={client_series}
                    xkey='Fecha'
                    ykeys={["Valor"]}
                    xtype='category'
                    ytype='number'
                    colors = {["#000000"]}
                    percTooltip={false}
                    legend={false}
                  />
                </div>
              </div>
            </>
            :null
            }
            {/*Exposición*/}
            {port_assetclass_exp!==null ?
            <>
              <div className="row m-4 justify-content-center">
                <div className='col'>
                  <hr></hr>
                </div>
              </div>
              <div className="row m-4 justify-content-center">
                <div className='col' id="exp">
                  <h5><b>Exposición</b></h5>
                  <a className='linkcol' href='#summ'>posicionamiento &uarr;</a>
                </div>
              </div>
              <div className="row mt-4 justify-content-center">
                <div className='col-md-4'>
                  <h6>Clase de Activo</h6>
                  <PiePlot 
                    data={port_assetclass_exp}
                    width={400}
                    height={350}
                    outerRadius={80}
                    percTooltip={true}
                    legend={true}
                    legendHeight={80}
                    dataKey='value'
                    nameKey='category'
                  />
                </div>
                <div className='col-md-4'>
                  <h6>Moneda</h6>
                  <PiePlot 
                    data={port_curr_exp}
                    width={400}
                    height={350}
                    outerRadius={80}
                    percTooltip={true}
                    legend={true}
                    legendHeight={80}
                    dataKey='value'
                    nameKey='category'
                  />
                </div>
                <div className='col-md-4'>
                  <h6>Mercados Desarrollados y Emergentes</h6>
                  <PiePlot 
                    data={port_mkt_exp}
                    width={400}
                    height={350}
                    outerRadius={80}
                    percTooltip={true}
                    legend={true}
                    legendHeight={80}
                    dataKey='value'
                    nameKey='category'
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col'>
                  <CSVLink className='link-btn' data={[...port_assetclass_exp.map(x=>{return {...x, variable:"Clase de Activo"}}), ...port_curr_exp.map(x=>{return {...x, variable:"Moneda"}}), ...port_mkt_exp.map(x=>{return {...x, variable:"Mercados Desarrollados y Emergentes"}})]} filename="portfolio"><small>Descargar exposición &darr;</small></CSVLink>
                </div>
              </div>
            </>
            :null
            }
          </div>
        );
      }
    }
}
//export default Port;
export default withRouter(connect(mapStateToProps)(ClientPortExposure));